// src/channel.ts
var GenericChannel = class {
  id;
  label;
  icon;
  events = [];
  maxSize;
  listeners = /* @__PURE__ */ new Set();
  constructor(id, label, icon, maxSize = 200) {
    this.id = id;
    this.label = label;
    this.icon = icon;
    this.maxSize = maxSize;
  }
  getEvents() {
    return this.events;
  }
  push(event) {
    this.events.push(event);
    if (this.events.length > this.maxSize) {
      this.events.shift();
    }
    this.notify();
  }
  clear() {
    this.events = [];
    this.notify();
  }
  subscribe(listener) {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }
  notify() {
    this.listeners.forEach((l) => {
      l();
    });
  }
};

// src/store.ts
var DevToolsStore = class {
  channels = /* @__PURE__ */ new Map();
  listeners = /* @__PURE__ */ new Set();
  channelUnsubs = /* @__PURE__ */ new Map();
  registerChannel(channel) {
    if (this.channels.has(channel.id)) {
      return;
    }
    this.channels.set(channel.id, channel);
    const unsub = channel.subscribe(() => {
      this.notify();
    });
    this.channelUnsubs.set(channel.id, unsub);
    this.notify();
  }
  unregisterChannel(id) {
    this.channelUnsubs.get(id)?.();
    this.channelUnsubs.delete(id);
    this.channels.delete(id);
    this.notify();
  }
  registerPlugin(plugin) {
    this.registerChannel(plugin.channel);
  }
  getChannel(id) {
    return this.channels.get(id);
  }
  getChannels() {
    return [...this.channels.values()];
  }
  clear() {
    this.channels.forEach((ch) => {
      ch.clear();
    });
  }
  subscribe(listener) {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }
  notify() {
    this.listeners.forEach((l) => {
      l();
    });
  }
};
var devToolsStore = new DevToolsStore();

export { DevToolsStore, GenericChannel, devToolsStore };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map